import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveSmallLeaderboardTopThreeDrop } from "./WaveSmallLeaderboardTopThreeDrop";
import { WaveSmallLeaderboardDefaultDrop } from "./WaveSmallLeaderboardDefaultDrop";
interface DefaultWaveSmallLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: () => void;
}
export const DefaultWaveSmallLeaderboardDrop: React.FC<DefaultWaveSmallLeaderboardDropProps> = t0 => {
  const $ = _c(6);
  const {
    drop,
    onDropClick
  } = t0;
  let t1;
  if ($[0] !== drop || $[1] !== onDropClick) {
    t1 = typeof drop.rank === "number" && drop.rank <= 3 ? <WaveSmallLeaderboardTopThreeDrop drop={drop} onDropClick={onDropClick} /> : <WaveSmallLeaderboardDefaultDrop drop={drop} onDropClick={onDropClick} />;
    $[0] = drop;
    $[1] = onDropClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onDropClick || $[4] !== t1) {
    t2 = <div className="tw-cursor-pointer" onClick={onDropClick}>{t1}</div>;
    $[3] = onDropClick;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};